import React, { useMemo } from 'react';
import { Avatar } from '@mui/material';
import { getUserAvatarUrl } from '../../constants/static-path-constants';
export const UserAvatar = ({ user }) => {
  const userName = user.name;
  const fallback = useMemo(
    () =>
      userName
        .split(' ')
        .map((el) => el.trim())
        .map((el) => el[0])
        .reduce((prev, el) => (prev.length < 2 ? `${prev}${el}` : prev), ''),
    [userName],
  );
  return (
    <Avatar
      alt={user.name}
      src={user.wwid ? getUserAvatarUrl(user.wwid, user.name) : undefined}
    >
      {fallback}
    </Avatar>
  );
};
